var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-actions',[_c('v-flex',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"href":_vm.data.payload.url,"target":"_blank"}},[_c('v-icon',[_vm._v("link")]),_vm._v(_vm._s(this.$t('go_message'))+"\n        ")],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }